import React from 'react'
import DropdownSelect from '../../../../../../common/inputs/dropdownSelect/DropdownSelect'
import { FlooringTypeOption } from '../../../../../../../@types/dropdown-types'
import { FieldProps } from '../../../../../../../@types/types'
import { OtherFacilitiesScreenValidationResult } from '../../../../../../../@types/validation-types'

const FlooringType: React.FC<FieldProps<OtherFacilitiesScreenValidationResult>> = ({
  insertionData,
  onChange,
  screenName,
  wrapperClassName = 'grid-item one-whole',
}) => {
  return (
    <div className={wrapperClassName}>
      <DropdownSelect
        id='flooring-type'
        name='flooringType'
        label='wizard.screen.otherFacilities.flooringType'
        value={insertionData.flooringType}
        noInformation={FlooringTypeOption.NO_INFORMATION}
        options={{
          translationKeyGroup: 'wizard.screen.otherFacilities.flooringTypes',
          options: Object.keys(FlooringTypeOption),
        }}
        onChange={(value) => onChange({ screen: screenName, property: 'flooringType' }, value.value!)}
        allowEmpty
      />
    </div>
  )
}

export default FlooringType
